import React from 'react';
import styled from '@emotion/styled';

export interface StandIconProps {
    size?: number;
    color?: string;
    className?: string;
    onClick?: () => void;
    'data-test'?: string;
    'data-test-id'?: string;
}

const IconWrapper = styled.span<{ size?: number }>`
    display: inline-block;
    width: ${({ size }) => (size ? `${size}px` : '24px')};
    height: ${({ size }) => (size ? `${size}px` : '24px')};

    svg {
        width: 100%;
        height: 100%;
    }
`;

const Stand: React.FC<StandIconProps> = (props) => {
    const { size = 24, color = 'currentColor', className, onClick } = props;

    return (
        <IconWrapper
            size={size}
            className={`align-middle ${className || ''}`}
            onClick={onClick}
            data-test={props['data-test']}
            data-test-id={props['data-test-id']}
            data-asper-icon
        >
            <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                {/* Presentation stand/easel icon */}
                <path d="M3 3H21V15H3V3Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 15V21" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M8 21L12 15L16 21"
                    stroke={color}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </IconWrapper>
    );
};

export default Stand;
